import React, { useState } from 'react'

import classNames from 'classnames'

import { BoxPriceSuitableForSection } from 'routes/BoxPrices/BoxPriceBlock/BoxPriceSuitableForSection'
import { BoxPricesTabs } from 'routes/BoxPrices/BoxPricesTabs'
import { Benefits } from 'routes/Home/Benefits'
import { NumberOfPortions } from 'routes/Menu/domains/basket'
import { signupConfig } from 'routes/Signup/signupConfig'

import { PrimaryButton } from '../PrimaryButton'
import { BoxDescriptionPlaceholderType } from '../types'
import { PricePerNRecipesTable } from './PricePerNRecipesTable'

import css from './GoustoOnDemandBoxSizeContent.css'

type GoustoOnDemandBoxSizeContentProps = {
  onPrimaryButtonClick: (value: NumberOfPortions) => void
  numPersonsToBoxDescriptors: { [key: string]: BoxDescriptionPlaceholderType[] }
  isLoadingPrices: boolean
  goustoOnDemandCustomText: string | null
}

export const GoustoOnDemandBoxSizeContent = ({
  onPrimaryButtonClick,
  numPersonsToBoxDescriptors,
  isLoadingPrices,
  goustoOnDemandCustomText,
}: GoustoOnDemandBoxSizeContentProps) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const { boxSizeTypes } = signupConfig.boxSizeStep

  const tabLabels = boxSizeTypes.map(({ heading }) => heading)

  return (
    <div>
      <div className={css.goustoOnDemandCustomText}>{goustoOnDemandCustomText}</div>
      <div className={css.tabsContainer}>
        <BoxPricesTabs
          activeIndex={activeIndex}
          labels={tabLabels}
          setActiveIndex={setActiveIndex}
        />
      </div>
      <div className={css.boxSizeCards}>
        {boxSizeTypes.map(({ heading, ctaText, value }, index) => {
          const boxDescriptors = numPersonsToBoxDescriptors[value]

          return (
            <div
              className={classNames(css.goustoOnDemandBoxSizeItem, {
                [css.isActive]: activeIndex === index,
              })}
              key={`box-size-for-${value}`}
            >
              <h2 className={css.goustoOnDemandBoxSizeItemHeading}>{heading}</h2>
              <BoxPriceSuitableForSection numPersons={value} />
              <PricePerNRecipesTable
                boxDescriptors={boxDescriptors}
                isLoadingPrices={isLoadingPrices}
              />
              <PrimaryButton
                value={value}
                onPrimaryButtonClick={onPrimaryButtonClick}
                ctaText={ctaText}
              />
            </div>
          )
        })}
      </div>
      <Benefits isCentered byId="everydayDelivery" fontStyleBody />
    </div>
  )
}
